import { forwardRef, useId } from 'react'
import { withLanguageContext } from 'context'
import Link from 'next/link'

const CustomLink = forwardRef(({ selectedLang, options, target, ...props }, ref) => {
	const id = useId()

	return (
		<Link
			ref={ref}
			id={id}
			rel={props.rel}
			className={`link-item ${props.className || ''}`}
			aria-label={props.ariaLabel || props.content || props.url}
			onMouseOver={props.onMouseOver}
			onMouseOut={props.onMouseOut}
			onMouseEnter={props.onMouseEnter}
			onMouseLeave={props.onMouseLeave}
			onClick={props.onClick}
			target={target}
			scroll={props.scroll}
			shallow={props.shallow}
			href={props.url}
			{...options}
		>
			{props.content || props.children}
		</Link>
	)
})

CustomLink.displayName = 'CustomLink'

export default withLanguageContext(CustomLink, ['selectedLang'])
